import GModal from 'tennders-market/common/components/element/GModal'
import { GButton, GInput, GSelect } from 'tennders-common/form/components'
import { INPUT_CHARACTER_LIMITS } from 'tennders-stracture/libs/constants'
import useTranslation from 'next-translate/useTranslation'
import { useToast } from 'tennders-common/hooks/useToast'
import { useDispatch, useSelector } from 'react-redux'
import useForm from 'tennders-common/form/hooks/useForm'
import { StateType } from 'tennders-common/types/StateType'
import { dispatchUpdatePaymentTerms } from 'tennders-common/stores/modal/action'
import React, { useEffect, useState } from 'react'
import useFetchOptions from 'tennders-common/hooks/useFetchOptions'
import { apiPut } from 'tennders-stracture/libs/api'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import GRadioGroup from '../../common/form/components/radiogroup'

const SPOT_PAYMENT_TERM = {
  days: 0,
  type: { name: 'SPOT', value: 'SPOT' }
}
const MUpdatePaymentTerms = () => {
  const { t } = useTranslation()
  const { refreshTransaction } = useTransaction()

  const dispatch = useDispatch()
  const { form, onChange, errors, setform, seterrors } = useForm({})
  const { toastError } = useToast()
  const { options } = useFetchOptions()
  const [saving, setSaving] = useState(false)
  const [paymentTerms, setPaymentTerms] = useState([])
  const transaction = useSelector((state:StateType) => state.modal.updatePaymentTerms)
  const paymentTermProps = { form, onChange, errors }
  const [standardSelected, setStandardSelected] = useState(form?.type === 'STANDARD')
  const close = () => {
    setform({})
    seterrors({})
    setSaving(false)
    setPaymentTerms([])
    dispatch(dispatchUpdatePaymentTerms(false))
  }

  const updatePaymentTerms = async () => {
    setSaving(true)
    const params = {
      price: parseInt(form?.bookRate, 10),
      priceType: form?.priceType,
      paymentTerm: form.type,
      paymentTermDateType: form.dType,
      paymentTermDays: form.days,
      cmrType: form.cmrType
    }
    try {
      const result = await apiPut(`loads/${transaction?.matchedLoad?.id}/paymentTerms`, params)
      console.log(result, 'result')
      setSaving(false)
      if (result?.error) {
        close()
        toastError(result.error)
      }

      close()
      refreshTransaction()
    } catch (e) {
      setSaving(false)
      if (e?.response?.data?.errors) {
        seterrors(e?.response?.data?.errors)
      }
    }
  }

  useEffect(() => {
    if (transaction?.matchedLoad) {
      setform({
        ...(transaction?.matchedLoad?.paymentTerm && {
          ...transaction?.matchedLoad?.paymentTerm,
          cmrType: transaction?.matchedLoad?.paymentTerm?.cmrType?.id
        }),
        ...(transaction?.matchedLoad?.bookRate && { bookRate: transaction?.matchedLoad?.bookRate }),
        ...(transaction?.matchedLoad?.priceType && { priceType: options?.priceTypes?.find((pt) => pt?.label?.toLowerCase() === transaction?.matchedLoad?.priceType)?.value })
      })
      const _paymentTerms = [
        ...(transaction?.matchedLoad?.company?.paymentTerm ? [transaction?.matchedLoad?.company?.paymentTerm] : []),
        SPOT_PAYMENT_TERM
      ]
      setPaymentTerms(_paymentTerms)
    }
  }, [transaction?.matchedLoad?.paymentTerm, transaction?.matchedLoad?.bookRate, transaction?.matchedLoad?.priceType, transaction?.matchedLoad?.company?.paymentTerm])

  useEffect(() => {
    if (form.type && (form.type !== SPOT_PAYMENT_TERM?.type.value)) {
      if (paymentTerms) {
        const pt = paymentTerms?.find((_pt) => _pt?.type?.value === form.type)
        if (pt) {
          setStandardSelected(true)

          setform({
            ...form,
            type: pt.type.value,
            cmrType: pt.cmrType.value,
            dType: pt.dateType,
            days: pt.days
          })
        }
      }
    } else {
      setStandardSelected(false)
    }
  }, [form?.type])

  return (
    <GModal
      isOpen={!!transaction}
      close={close}
      size={600}
    >
      <div className="tennders-modal-body w-100">
        <div className="d-flex">
          <div className="p-20">
            <h3 className="bold">{t('addLoad:update_payment_terms')}</h3>
            <div className="tennders-grid-2-col gap-10">
              <GInput
                {...paymentTermProps}
                type="currency"
                name="bookRate"
                label="Price"
                maxLength={INPUT_CHARACTER_LIMITS.PRICE}
                className="form-input"
                error={errors?.price}
              />
              <GSelect
                {...paymentTermProps}
                className="form-input"
                items={options?.priceTypes}
                name="priceType"
                label="Price Type"
                eClass="mr-0"
                disabled
              />
              <GSelect
                {...paymentTermProps}
                className="form-select"
                items={paymentTerms?.map((pt) => ({
                  label: t(`variables:${pt?.type?.name}`),
                  value: pt?.type?.value
                }))}
                name="type"
                label="Payment Type"
                eClass="mr-0"
              />
              <GSelect
                {...paymentTermProps}
                className="form-input"
                items={options?.paymentTermDateTypes}
                disabled={standardSelected}
                name="dType"
                label="Payment From"
                eClass="mr-0"
              />
              <GInput
                {...paymentTermProps}
                type="number"
                name="days"
                readOnly={standardSelected}
                label="Days"
                className="form-input"
                error={errors?.paymentTermDays}
              />
              <GRadioGroup
                label="CMR"
                name="cmrType"
                disabled={standardSelected}
                items={options?.cmrTypes}
                {...paymentTermProps}
              />
            </div>
            <GButton
              onClick={updatePaymentTerms}
              submitting={saving}
              className="btn standard-btn cursor-pointer mt-20"
            >
              {t('modals:save')}
            </GButton>
          </div>
        </div>
      </div>
    </GModal>
  )
}

export default MUpdatePaymentTerms
